import type { AiCapabilityPage } from "../schema.js";
import { LIVE, MANAGER_ROLES } from "./_shared.js";

/**
 * `TX-LABEL` (@UC0216) — trang **redirect** (US-AIV2-0049): chat KHÔNG hỏi ô, KHÔNG có nút Đồng ý,
 * chỉ một câu giải thích + nút mở đúng màn hình `/groups/:groupId/activities` (ADR-0009 bất biến 5).
 * US-AIV2-0110 S10 (`@UC0259`): trước trỏ trang chủ nhóm `/groups/:groupId`; nay tab "Hoạt động" — bấm một dòng mở màn chi tiết nơi làm việc này.
 * Cửa mobile trang này chịu trách nhiệm (QĐ PO 17/09 mục 11 — gắn nhãn giao dịch, tạm redirect).
 */
export const TX_LABEL = {
  id: "TX-LABEL",
  uc: "@UC0216",
  tier: "redirect",
  status: LIVE,
  roles: MANAGER_ROLES,
  flags: [],
  slots: [],
  llm: {
    description: "Gắn nhãn cho một giao dịch trong sổ để sau này tìm và gom nhóm cho dễ.",
    examples: [
      "gắn nhãn giao dịch",
      "gan nhan giao dich",
      "đặt nhãn cho khoản này",
      "dat nhan cho khoan nay",
      "sửa nhãn",
      "nhãn giao dịch",
      // ——— 0105: thêm cho đủ 40 ———
      "sua nhan",
      "nhan giao dich",
      "gắn nhãn cho giao dịch trong sổ",
      "gan nhan cho giao dich trong so",
      "đánh nhãn khoản vừa ghi",
      "danh nhan khoan vua ghi",
      "phân loại giao dịch bằng nhãn",
      "phan loai giao dich bang nhan",
      "thêm nhãn vào giao dịch này",
      "them nhan vao giao dich nay",
      "gỡ nhãn khỏi giao dịch",
      "go nhan khoi giao dich",
      "đổi nhãn của giao dịch",
      "doi nhan cua giao dich",
      "gắn thẻ cho khoản này để sau tìm cho dễ",
      "gan the cho khoan nay de sau tim cho de",
      "nhãn cho khoản trong sổ quỹ",
      "nhan cho khoan trong so quy",
      "gắn nhãn tiền ăn cho giao dịch",
      "gan nhan tien an cho giao dich",
      "muốn gom các giao dịch cùng loại bằng nhãn",
      "muon gom cac giao dich cung loai bang nhan",
      "tag giao dịch",
      "tag giao dich",
      "đặt nhãn mới",
      "dat nhan moi",
      "xem nhãn của giao dịch này",
      "xem nhan cua giao dich nay",
      "gắn nhãn giúp mình khoản vừa rồi",
      "gan nhan giup minh khoan vua roi",
      "sửa lại nhãn ghi sai",
      "sua lai nhan ghi sai",
      "gắn nhãn cho mấy khoản chi tháng này",
      "gan nhan cho may khoan chi thang nay",
    ],
  },
  screen: "/groups/:groupId/activities",
  screenShows: "transaction_label",
  endpoints: [
    "GET /funds/{fundId}/transactions/{txId}/label",
    "PUT /funds/{fundId}/transactions/{txId}/label",
  ],
  facts: [],
  templates: {
    // 🔴 GUIDE-SCREEN-TRUTH (G-1, @UC0216): app chỉ cho sửa ô Tiêu đề ở dòng CHI QUỸ (`canEditTitle` = `fundExpense`; tiêu đề = tên khoản
    // chi); dòng nộp quỹ khoá ô đó (`activity_detail_label_locked_hint`: "lấy theo đợt thu, không sửa được").
    redirect:
      "Mình mở hoạt động của nhóm nhé — bấm vào một khoản chi để sửa tiêu đề (tên khoản chi). Dòng nộp quỹ thì tiêu đề lấy theo đợt thu, không sửa được. Đổi chữ không đổi một đồng nào trong sổ.",
  },
  journey: { after: ["GRP-ACTIVITY"] },
  help: { title: "Gắn nhãn giao dịch", tryNow: "gắn nhãn giao dịch" },
} satisfies AiCapabilityPage;
